import React from 'react';
import { Link } from 'react-router-dom';

const CommitUserList = props => {
    if (!props.users) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.users.length === 0) {
        return (
            <div className='empty'>
                No users...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>id</th>
                        <th>first name</th>
                        <th>last name</th>
                        <th>email</th>
                        <th>phone</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.users.map(user => {
                            return (
                                <tr key={user.email}>
                                    <td className="keyfield"><Link to={`/users/${user.key}`}>{user.key}</Link></td>
                                    <td>{user.firstname}</td>
                                    <td>{user.lastname}</td>
                                    <td>{user.email}</td>
                                    <td>{user.phone}</td>
                                    <td className="keyfield"><Link to={`/user/${user.key}/${props.type}/transactions`}>{'view transactions'}</Link></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CommitUserList;



// WEBPACK FOOTER //
// ./src/components/widgets/CommitUserList.js